// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"14":"0d574c66","987":"45039635"}[chunkId] + ".css";
};